var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2959 10.4651H16.7927L16.7903 7.9553C16.7879 5.22172 14.5639 2.99776 11.8311 3C9.09755 3.00239 6.87359 5.22641 6.87522 7.95917L6.8792 10.4683L6.70004 10.4691C5.76043 10.4715 4.9976 11.2335 5.00001 12.1731V19.6437C5.00001 20.5833 5.76443 21.3461 6.70404 21.3461L17.3 21.3398C18.2396 21.3398 19.0024 20.5777 19 19.6373V12.1651C19 11.2255 18.2356 10.4651 17.296 10.4651L17.2959 10.4651ZM8.70566 10.469L8.70168 7.95989C8.70168 6.23356 10.1039 4.82902 11.8311 4.82657C13.5575 4.82657 14.962 6.23119 14.962 7.95602L14.966 10.4652L8.70566 10.469Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a111af723054856764994d459528f59e.svg";
export { ForwardRef as ReactComponent };